<template>
  <section class="" id="testimonial">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12">
<!--          <div class="appie-testimonial-slider" style="position:relative">-->
          <div class="" style="position:relative">
<!--            <span class="prev slick-arrow" style="display: block;" @click.prevent="showNext"><i class="fal fa-arrow-left"></i></span>-->
            <VueSlickCarousel v-bind="settings" ref="carousel" class="row whitebackground p-2">
              <template v-for="(sliderContent,index)  in sliderContents" class="">
                <div :key="index" class="appie-testimonial-item text-center">

                  <div class="author-info">
                    <div v-if="sliderContent.view_type === 'image' && sliderContent.src">
                      <a :href="sliderContent.url" target="_blank">
                      <img :src="sliderContent.src" alt="" /></a>
                    </div>
                    <div  v-else-if="sliderContent.view_type === 'video' && sliderContent.src">
                      <iframe
                          class="videoMedia"
                          :src="getEmbedUrl(sliderContent.src)"
                          title="YouTube video player"
                          frameborder="0"
                          allowfullscreen
                      ></iframe>

                    </div>
                  </div>
<!--                  <div class="text">-->
<!--                    <p>{{sliderContent.description}}</p>-->
<!--                    <ul>-->
<!--                      <li v-for="(rating,index) in sliderContent.ratings" :key="index">-->
<!--                        <i class="fas fa-star"></i>-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </div>-->
                </div>
              </template>

            </VueSlickCarousel>
<!--            <span @click.prevent="showPrev" class="next slick-arrow" style="display: block;"><i class="fal fa-arrow-right"></i></span>-->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
// import axios from 'axios';


export default {
  components:{ VueSlickCarousel},
  props: {
    // sliderContents:{
    //   type: Array,
    //   default:()=>{
    //     return []
    //   }
    // }
  },
  data(){
    return {
      sliderContents:[],
      settings: {
        // slidesToShow: 2, // Show two slides at a time
        // slidesToScroll: 1,

        autoplay: true,
        arrows:false,
        dots:true,
        // infinite: true,
        // speed: 300,

      },




    }
  },
  created() {
   // let slider = localStorage.getItem("carousel")
   //  this.sliderContents= slider.slider;

   //  console.log('slider', slider);

    let slider = localStorage.getItem('carousel');
    this.sliderContents = JSON.parse(slider);

  },

  methods:{

    getVideoId(url) {
      const parts = url.split('/').filter(Boolean);
      return parts[parts.length - 1];
    },

    getEmbedUrl(url) {
      const videoId = this.getVideoId(url);
      return `https://www.youtube.com/embed/${videoId}`;
    },



    showNext() {
      this.$refs.carousel.next()
    },
    showPrev(){
      this.$refs.carousel.prev()
    },
  }

}
</script>

<style>
.appie-testimonial-slider-rtl .slick-dots, .appie-testimonial-slider .slick-dots{
  bottom: unset !important;
}

.slick-dots li button:before {
  content: '';

}
.appie-testimonial-slider .slick-arrow.prev {
  left: 20%;
}
.appie-testimonial-slider .slick-arrow {
  top: 50%;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {


}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {

}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .videoMedia {
    width: 560px;
    height: 290px;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .videoMedia {
    width: 560px;
    height: 290px;
  }
}

</style>
